// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bottom Navigation */
.bottom-nav {
  background: var(--color-white);
  border-top: 0.0625rem solid var(--color-border-primary);
  padding: var(--space-sm) 0;
  position: sticky;
  bottom: 0;
  z-index: 100;
}

.nav-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-xs);
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--space-sm);
  border-radius: var(--radius-md);
  transition: all var(--duration-fast) var(--easing-ease-out);
  flex: 1 1;
  max-width: 5rem;
}

.nav-item:hover {
  background: var(--color-gray-50);
}

.nav-item.active {
  background: none;
}

.nav-item.active .nav-icon {
  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.nav-item.active .nav-label {
  color: rgba(60, 60, 60, 1);
  font-weight: var(--font-weight-semibold);
}

.nav-icon {
  width: 1.5rem;
  height: 1.5rem;
  transition: all var(--duration-fast) var(--easing-ease-out);
  filter: brightness(0) saturate(100%) invert(80%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
}

.nav-label {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.875rem; /* 14px */
  line-height: 1rem; /* 16px */
  letter-spacing: 0%;
  color: rgba(204, 209, 209, 1);
  font-weight: var(--font-weight-normal);
  text-align: center;
  transition: all var(--duration-fast) var(--easing-ease-out);
}

/* Desktop Responsive Design */
@media (min-width: 768px) {
  .home-screen {
    min-height: 100vh;
    padding-bottom: 0;
  }

  /* Desktop Navigation - Centered */
  .bottom-nav {
    position: fixed;
    bottom: var(--space-lg);
    left: 50%;
    transform: translateX(-50%);
    background: var(--color-white);
    border-radius: var(--radius-2xl);
    border: 0.0625rem solid var(--color-border-primary);
    box-shadow: var(--shadow-lg);
    margin: 0;
    z-index: 1000;
  }

  .nav-container {
    justify-content: center;
    gap: var(--space-lg);
    width: auto;
  }

  .nav-item {
    max-width: none;
    padding: var(--space-md);
  }

  .nav-label {
    font-size: var(--font-size-sm);
  }
}


@media (min-width: 1440px) {
  .bottom-nav {
    bottom: var(--space-xl);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,8BAA8B;EAC9B,uDAAuD;EACvD,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,2DAA2D;EAC3D,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wHAAwH;AAC1H;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,2DAA2D;EAC3D,wHAAwH;AAC1H;;AAEA;EACE,qCAAqC;EACrC,mBAAmB,EAAE,SAAS;EAC9B,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB;EAClB,6BAA6B;EAC7B,sCAAsC;EACtC,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,uBAAuB;IACvB,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,gCAAgC;IAChC,mDAAmD;IACnD,4BAA4B;IAC5B,SAAS;IACT,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;AACF;;;AAGA;EACE;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Bottom Navigation */\n.bottom-nav {\n  background: var(--color-white);\n  border-top: 0.0625rem solid var(--color-border-primary);\n  padding: var(--space-sm) 0;\n  position: sticky;\n  bottom: 0;\n  z-index: 100;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n}\n\n.nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-xs);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: var(--space-sm);\n  border-radius: var(--radius-md);\n  transition: all var(--duration-fast) var(--easing-ease-out);\n  flex: 1;\n  max-width: 5rem;\n}\n\n.nav-item:hover {\n  background: var(--color-gray-50);\n}\n\n.nav-item.active {\n  background: none;\n}\n\n.nav-item.active .nav-icon {\n  filter: brightness(0) saturate(100%) invert(23%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\n}\n\n.nav-item.active .nav-label {\n  color: rgba(60, 60, 60, 1);\n  font-weight: var(--font-weight-semibold);\n}\n\n.nav-icon {\n  width: 1.5rem;\n  height: 1.5rem;\n  transition: all var(--duration-fast) var(--easing-ease-out);\n  filter: brightness(0) saturate(100%) invert(80%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);\n}\n\n.nav-label {\n  font-family: 'Montserrat', sans-serif;\n  font-size: 0.875rem; /* 14px */\n  line-height: 1rem; /* 16px */\n  letter-spacing: 0%;\n  color: rgba(204, 209, 209, 1);\n  font-weight: var(--font-weight-normal);\n  text-align: center;\n  transition: all var(--duration-fast) var(--easing-ease-out);\n}\n\n/* Desktop Responsive Design */\n@media (min-width: 768px) {\n  .home-screen {\n    min-height: 100vh;\n    padding-bottom: 0;\n  }\n\n  /* Desktop Navigation - Centered */\n  .bottom-nav {\n    position: fixed;\n    bottom: var(--space-lg);\n    left: 50%;\n    transform: translateX(-50%);\n    background: var(--color-white);\n    border-radius: var(--radius-2xl);\n    border: 0.0625rem solid var(--color-border-primary);\n    box-shadow: var(--shadow-lg);\n    margin: 0;\n    z-index: 1000;\n  }\n\n  .nav-container {\n    justify-content: center;\n    gap: var(--space-lg);\n    width: auto;\n  }\n\n  .nav-item {\n    max-width: none;\n    padding: var(--space-md);\n  }\n\n  .nav-label {\n    font-size: var(--font-size-sm);\n  }\n}\n\n\n@media (min-width: 1440px) {\n  .bottom-nav {\n    bottom: var(--space-xl);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
